export enum SignatureType {
    MANUAL = 'manual',
    SPROOF = 'sproof',
    SIGNTEQ = 'signteq',
}

export enum SignatureDocumentType {
    EMISSION = 'emission',
    ESAC_FORM_A = 'esac_form_a',
    ESAC_FORM_B = 'esac_form_b',
    ESAC_FORM_C = 'esac_form_c',
    ESAC_FORM_D = 'esac_form_d',
    ESAC_LEGAL_ENTITY = 'esac_legal_entity',
    ESAC_LEGAL_UBO = 'esac_legal_ubo',
    ESAC_NATURAL_PERSON = 'esac_natural_person',
}
